<template>
  <svg width="80" height="40" viewBox="0 0 80 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="80" height="40" rx="4" fill="#F8F9FA"/>
    <mask id="path-2-inside-1_13997_26148" fill="white">
      <path d="M44 10C44 8.89543 44.8954 8 46 8H58C59.1046 8 60 8.89543 60 10V18H44V10Z"/>
    </mask>
    <path d="M44 10C44 8.89543 44.8954 8 46 8H58C59.1046 8 60 8.89543 60 10V18H44V10Z" fill="#F8F9FA"/>
    <path d="M60 18V19H61V18H60ZM44 18H43V19H44V18ZM46 8V9H58V8V7H46V8ZM60 10H59V18H60H61V10H60ZM60 18V17H44V18V19H60V18ZM44 18H45V10H44H43V18H44ZM58 8V9C58.5523 9 59 9.44772 59 10H60H61C61 8.34315 59.6569 7 58 7V8ZM46 8V7C44.3431 7 43 8.34315 43 10H44H45C45 9.44772 45.4477 9 46 9V8Z" fill="#B4BFCB" mask="url(#path-2-inside-1_13997_26148)"/>
    <mask id="path-4-inside-2_13997_26148" fill="white">
      <path d="M26 10C26 8.89543 26.8954 8 28 8H40C41.1046 8 42 8.89543 42 10V18H26V10Z"/>
    </mask>
    <path d="M26 10C26 8.89543 26.8954 8 28 8H40C41.1046 8 42 8.89543 42 10V18H26V10Z" fill="#F8F9FA"/>
    <path d="M42 18V19H43V18H42ZM26 18H25V19H26V18ZM28 8V9H40V8V7H28V8ZM42 10H41V18H42H43V10H42ZM42 18V17H26V18V19H42V18ZM26 18H27V10H26H25V18H26ZM40 8V9C40.5523 9 41 9.44772 41 10H42H43C43 8.34315 41.6569 7 40 7V8ZM28 8V7C26.3431 7 25 8.34315 25 10H26H27C27 9.44772 27.4477 9 28 9V8Z" fill="#B4BFCB" mask="url(#path-4-inside-2_13997_26148)"/>
    <mask id="path-6-inside-3_13997_26148" fill="white">
      <path d="M8 10C8 8.89543 8.89543 8 10 8H22C23.1046 8 24 8.89543 24 10V18H8V10Z"/>
    </mask>
    <path d="M8 10C8 8.89543 8.89543 8 10 8H22C23.1046 8 24 8.89543 24 10V18H8V10Z" fill="#F8F9FA"/>
    <path d="M7 10C7 8.34315 8.34315 7 10 7H22C23.6569 7 25 8.34315 25 10H23C23 9.44772 22.5523 9 22 9H10C9.44772 9 9 9.44772 9 10H7ZM24 18H8H24ZM7 18V10C7 8.34315 8.34315 7 10 7V9C9.44772 9 9 9.44772 9 10V18H7ZM22 7C23.6569 7 25 8.34315 25 10V18H23V10C23 9.44772 22.5523 9 22 9V7Z" fill="#B4BFCB" mask="url(#path-6-inside-3_13997_26148)"/>
    <mask id="path-8-inside-4_13997_26148" fill="white">
      <path d="M8 17H70C71.1046 17 72 17.8954 72 19V32H8V17Z"/>
    </mask>
    <path d="M7 16H70C71.6569 16 73 17.3431 73 19H71C71 18.4477 70.5523 18 70 18H9L7 16ZM72 32H8H72ZM7 32V16L9 18V32H7ZM70 16C71.6569 16 73 17.3431 73 19V32H71V19C71 18.4477 70.5523 18 70 18V16Z" fill="#B4BFCB" mask="url(#path-8-inside-4_13997_26148)"/>
    <rect x="12" y="21" width="13" height="2" rx="1" fill="#DEE3E6"/>
    <rect x="12" y="25" width="49" height="2" rx="1" fill="#DEE3E6"/>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
